import React, { useMemo } from 'react';
import InputSection from './InputSection';
import KPITable from './KPITable';
import SliderSection from './SliderSection';
import PropertyPhoto from './PropertyPhoto';
import AnalyzerCharts from './AnalyzerCharts';
import AnalyzerSummary from './AnalyzerSummary';
import SensitivityAnalysis from './SensitivityAnalysis';
import { useApp } from '../../contexts/AppContext';
import { calculateSingleProperty } from '../../utils';

const PropertyAnalyzer: React.FC = () => {
  const { 
    currentInputs, 
    saveProperty, 
    loadProperty, 
    createNewProperty,
    portfolio,
    activePropertyId 
  } = useApp();

  const calculations = useMemo(() => {
    return calculateSingleProperty(currentInputs);
  }, [currentInputs]);

  return (
    <div className="tab-content active">
      {/* Control Buttons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 my-8 max-w-4xl mx-auto">
        <button
          onClick={saveProperty}
          className="w-full sm:col-span-1 px-4 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        >
          Immobilie Speichern
        </button>
        <button
          onClick={createNewProperty}
          className="w-full sm:col-span-1 px-4 py-2 bg-gray-300 text-gray-800 font-semibold rounded-md shadow-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
        >
          Neue Immobilie
        </button>
        <div className="w-full sm:col-span-2 lg:col-span-1 flex flex-col sm:flex-row items-start sm:items-center gap-2">
          <label htmlFor="load-property-select" className="text-sm font-medium text-gray-700 whitespace-nowrap">
            Immobilie laden:
          </label>
          <select
            id="load-property-select"
            value={activePropertyId || ''}
            onChange={(e) => loadProperty(e.target.value)}
            className="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">-- Wählen --</option>
            {portfolio.map(property => (
              <option key={property.id} value={property.id}>
                {property.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Photo Upload Section */}
      <div className="flex justify-center mb-8">
        <PropertyPhoto />
      </div>

      {/* Slider Section */}
      <SliderSection />

      {/* Input Section */}
      <InputSection />

      {/* KPI Table */}
      <KPITable calculations={calculations} />

      {/* Summary Section */}
      <AnalyzerSummary calculations={calculations} />

      {/* Charts Section */}
      <AnalyzerCharts calculations={calculations} />
      
      {/* Sensitivity Analysis Section */}
      <SensitivityAnalysis calculations={calculations} />
    </div>
  );
};

export default PropertyAnalyzer;